import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons"
import { Box, ButtonGroup, IconButton, Text } from "@chakra-ui/react"

type PaginationProps = {
  pageNumber: number
  pageSize: number
  setPageNumber: (n: number) => void
  totalElements: number
  totalPages: number
}
const Pagination = ({
  pageSize,
  pageNumber,
  setPageNumber,
  totalElements,
  totalPages,
}: PaginationProps) => {
  return (
    <Box display='flex' alignItems='center'>
      <Text fontSize={{ base: "12px", xl: "14px", xxl: "16px" }} mr='20px'>
        {`${pageNumber ? pageNumber * pageSize + 1 : 1} - ${Math.min(
          pageNumber * pageSize + pageSize,
          totalElements,
        )} of ${totalElements}`}
      </Text>

      <ButtonGroup
        isAttached
        variant='outline'
        border='2px solid secondary.900'
      >
        <IconButton
          aria-label='previous page'
          icon={<ArrowLeftIcon h={3} w={3} />}
          onClick={() => {
            setPageNumber(0)
          }}
          isDisabled={pageNumber <= 0}
        />
        <IconButton
          aria-label='previous page'
          icon={<ChevronLeftIcon h={7} w={7} />}
          onClick={() => {
            setPageNumber(pageNumber > 0 ? pageNumber - 1 : 0)
          }}
          isDisabled={pageNumber <= 0}
        />

        <IconButton
          aria-label='next page'
          icon={<ChevronRightIcon h={7} w={7} />}
          onClick={() =>
            setPageNumber(
              pageNumber < (totalPages > 0 ? totalPages - 1 : totalPages)
                ? pageNumber + 1
                : pageNumber,
            )
          }
          isDisabled={
            pageNumber === (totalPages > 0 ? totalPages - 1 : totalPages)
          }
        />
        <IconButton
          aria-label='next page'
          icon={<ArrowRightIcon h={3} w={3} />}
          onClick={() =>
            setPageNumber(totalPages > 0 ? totalPages - 1 : totalPages)
          }
          isDisabled={
            pageNumber === (totalPages > 0 ? totalPages - 1 : totalPages)
          }
        />
      </ButtonGroup>
    </Box>
  )
}

export default Pagination
